/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';

import { Header, Footer } from 'components';
import { InputField, Section, Button } from '@fitinsur/components';
import { Col, Row } from 'components/Grid';

import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import Access from 'constants/Access';

import { ForgotPasswordContainer, ButtonContainer, BaseWrapper } from './styles';
import TopHeader from 'components/TopHeader/index';
import { LoaderContext } from '@fitinsur/contexts';

export default function ForgotPasswordPage() {
  const authContext = useContext(GlobalAuthContext);
  const { updateIsLoadingStatus } = useContext(LoaderContext);

  const [forgotPasswordState, setForgotPasswordState] = useState(authContext.forgotPassword);
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState(forgotPasswordState == true ? "Email enviado com sucesso" : "Você esqueceu sua senha? Por favor informe seu endereço de email (o mesmo usado para o acesso) e iremos enviar um e-mail com o processo de alteração de senha.");
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();

  const goToHomePage = () => {
    history.push('home');
  };

  const goToLoginPage = () => {
    history.push('login');
  };

  return (
    <BaseWrapper>
      <TopHeader />
      <ForgotPasswordContainer>
        <Row>
          <Col xs={12} md={12}>
            <Header title="Esqueci minha senha" subtitle={forgotPasswordMessage} disableLogo={true} />
          </Col>
        </Row>
        <Formik
          initialValues={{
            username: '',
          }}

          validationSchema={Yup.object({
            username: Yup.string().email('Email inválido').required('* Campo obrigatório')
          })}

          onSubmit={values => {
            updateIsLoadingStatus(true);

            console.log("onSubmit - BEGIN");
            if (forgotPasswordState == true) {
              setForgotPasswordMessage("Email enviado com sucesso!");
              setForgotPasswordState(true);
              updateIsLoadingStatus(false);
              console.log("onSubmit - Existing authentication - END");
              return;
            }
            fitinsur.requestForgotPassword(values.username, Access.APLICATION)
              .then((response) => {
                console.log(response);
                return response.json();
              })
              .then((data) => {
                console.log('requestForgotPassword - Success:', data);
                if (data.ret_code == "200") {
                  authContext.username = values.username;
                  authContext.token = data.ret_token;
                  authContext.person_product = data.ret_person_product;
                  authContext.user_region = data.ret_user_region;

                  console.log("requestForgotPassword: authContext");
                  console.log(authContext);

                  setForgotPasswordMessage("Email enviado com sucesso!");
                  setForgotPasswordState(true);
                  mc.success("Email enviado com sucesso!");
                  goToLoginPage();
                  //setTimeout(() => goToLoginPage(), 5000);
                } else {
                  authContext.username = values.username;
                  authContext.token = "";
                  authContext.person_product = [];
                  authContext.user_region = "";
                  const errorMsg = data.ret_code < 500 ?
                    data.ret_msg_details :
                    'Não foi possível processar a solicitação. Por favor verifique e tente novamente.'
                  setForgotPasswordMessage(errorMsg);
                  mc.error(errorMsg);
                  setForgotPasswordState(false);
                }
                updateIsLoadingStatus(false);
              })
              .catch((error) => {
                authContext.username = values.username;
                authContext.token = "";
                authContext.person_product = [];
                authContext.user_region = "";

                console.error('requestForgotPassword - Error:', error);
                setForgotPasswordMessage("Não foi possível processar a solicitação. Por favor verifique e tente novamente.");
                mc.error('Não foi possível processar a solicitação. Por favor verifique e tente novamente.');
                setForgotPasswordState(false);
                updateIsLoadingStatus(false);
              });

            console.log("onSubmit - END");
          }}
        >

          {(props) => (
            <Form>

              <Section>

                {/* <div style={{marginTop: 25}}/> */}
                <Row>
                  <Col xs={12} md={12}>
                    <Field
                      name="username"
                      label="E-mail:"
                      type="text"
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                      disabled={forgotPasswordState == true}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12} style={{ position: "static" }}>
                    <ButtonContainer>
                      <Button
                        primary type="submit"
                        id="btnForgotPassword"
                        style={{}}
                        disabled={forgotPasswordState == true}>
                        Enviar
                      </Button>
                    </ButtonContainer>
                  </Col>

                </Row>
              </Section>

            </Form>
          )}

        </Formik>
      </ForgotPasswordContainer>
      <Footer />
    </BaseWrapper >

  );
}
